import styled from 'styled-components';
import { astriskStyle } from 'src/styles/CommonStyles.styled';

export const RetractorUsedContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
`;

export const CheckRowDiv = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: 8px;

    ${astriskStyle};
`;

export const SubTitle = styled.div`
    font-family: AvenirNextWorld Italic;
    color: #140f4b;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    margin: ${({ margin }) => (margin ? margin : '0 0 8px 0')};
    padding: ${({ padding }) => (padding ? padding : '')};
    display: flex;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'flex-start'};
`;
